import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  Box,
  Center,
  SearchInput,
  SearchInputField,
} from '@frontend/legacy-components';

import { SUPPLIER_ROLES, PERMISSIONS } from 'constants/all';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { useFeatureFlagValue } from 'store/session/hooks';
import { getGroupMemberSupplierRoles } from 'store/session/selectors';

import { SearchOverlay } from './SearchOverlay';
import SearchResults from './SearchResults';
import { useSearchDataContext } from './context';

export const SearchBarLarge = () => {
  const roles = useSelector(getGroupMemberSupplierRoles);
  const isQuotingAvailable = useFeatureFlagValue(
    featureFlagKeys.isQuotingToolAvailable,
  );
  const areQuotesAvailable =
    isQuotingAvailable &&
    roles[SUPPLIER_ROLES.QUOTES] !== PERMISSIONS.NO_ACCESS;
  const areOrdersAvailable =
    areQuotesAvailable &&
    roles[SUPPLIER_ROLES.ORDERS] !== PERMISSIONS.NO_ACCESS;

  const { searchTerm, setSearchTerm } = useSearchDataContext();
  const [overlayIsDisplayed, setOverlayIsDisplayed] = useState<boolean>(false);

  const resultsAreDisplayed = searchTerm !== '' && overlayIsDisplayed;

  useEffect(() => {
    const body = document.getElementById('scrollRoot');
    if (body) {
      if (overlayIsDisplayed) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = '';
      }
    }
  }, [overlayIsDisplayed]);

  if (!areOrdersAvailable && !areQuotesAvailable) {
    return null;
  }

  return (
    <>
      <Center
        position="relative"
        transition="0.2s ease all"
        width="100%"
        zIndex="dropdown"
      >
        <Box width="100%">
          <SearchInput
            size="lg"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setOverlayIsDisplayed(true);
            }}
            onClear={() => {
              setSearchTerm('');
              setOverlayIsDisplayed(false);
            }}
            onFocus={() => setOverlayIsDisplayed(true)}
          >
            <SearchInputField
              borderBottomColor={
                resultsAreDisplayed ? 'separator.divider' : 'separator.border'
              }
              borderBottomLeftRadius={resultsAreDisplayed ? '0px' : undefined}
              borderBottomRightRadius={resultsAreDisplayed ? '0px' : undefined}
              placeholder="Search by quote number, contact, part number, PDF text, notes, or keywords"
              maxLength={500}
            />
          </SearchInput>
        </Box>
        {resultsAreDisplayed && (
          <Box width="100%" position="absolute" top={1}>
            <SearchResults
              height={{ base: 'unset', tablet: 'calc(100vh - 220px)' }}
            />
          </Box>
        )}
      </Center>
      {overlayIsDisplayed && (
        <SearchOverlay
          onClick={() => setOverlayIsDisplayed(false)}
          data-testid="overlay"
        />
      )}
    </>
  );
};
